/**
 * Content rendering decision logic
 * Determines how to render AI-generated content
 */

import { containsMarkdown, normalizeLineBreaks } from './formatters';

export interface RenderDecision {
  normalized: string;
  shouldUseMarkdown: boolean;
}

/**
 * Analyze content and decide rendering strategy
 */
export function analyzeContent(content: string): RenderDecision {
  const normalized = normalizeLineBreaks(content);
  const shouldUseMarkdown = containsMarkdown(normalized);
  
  return {
    normalized,
    shouldUseMarkdown,
  };
}
